import React from 'react';
import { Box, Dialog } from '@mui/material';

interface EnlargedImageDialogProps {
    /** The object URL to show. `null` closes the dialog. */
    url: string | null;
    onClose: () => void;
}

/**
 * A decrypted clinical image at full size. Open when `url` is non-null.
 *
 * SKIN-240 — extracted so the QC review gallery and the clinical submission view share one
 * dialog rather than two identical ones. Deriving `open` from `url` rather than holding a
 * separate boolean is what lets a caller close the dialog by dropping the URL — which the
 * gallery relies on, because an image that stops being showable (a retry in flight) must
 * not leave a dialog rendering a revoked `blob:` reference.
 */
export default function EnlargedImageDialog({ url, onClose }: EnlargedImageDialogProps) {
    return (
        <Dialog open={!!url} onClose={onClose} maxWidth="lg">
            {url && (
                <Box
                    component="img"
                    src={url}
                    alt=""
                    data-testid="enlarged-image"
                    sx={{ maxWidth: '90vw', maxHeight: '90vh', objectFit: 'contain' }}
                />
            )}
        </Dialog>
    );
}
